/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Delete_ConfirmInputs */



/**
* | output |
* | --- |
* | "This will permanently revoke this API key. Any applications using it will stop working." |
*
* @param {Profile_Security_User_Api_Key_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_delete_confirm = /** @type {((inputs?: Profile_Security_User_Api_Key_Delete_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Delete_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser API-Schlüssel wird dauerhaft widerrufen. Alle Anwendungen, die ihn verwenden, funktionieren nicht mehr.")
	return /** @type {LocalizedString} */ ("This will permanently revoke this API key. Any applications using it will stop working.")
});